// Component tokens — wartości specyficzne dla konkretnych, nazwanych komponentów domenowych
// (ChallengeHero, LeaderboardRow, IntegrationHealthCard, CampaignStepper, itd.)
// Budowane na bazie warstwy semantic, nie primitive.
import { radius, spacing } from './primitive';

export function getComponentTokens(semantic) {
  return {
    challengeHero: {
      radius: radius.hero,
      padding: spacing[6],
      background: semantic.surface.base,
      border: `1px solid ${semantic.border.subtle}`,
      shadow: semantic.shadow.soft,
      imageRadius: radius.card,
    },
    campaignCard: {
      radius: radius.card,
      padding: spacing[5],
      background: semantic.surface.base,
      border: `1px solid ${semantic.border.subtle}`,
    },
    progressArc: {
      track: semantic.progress.track,
      fill: semantic.progress.fill,
      strokeWidth: 10,
    },
    leaderboardRow: {
      radius: radius.control,
      hoverBackground: semantic.surface.brandTint,
      selfBorder: `1.5px solid ${semantic.action.primary}`,
    },
    integrationHealthCard: {
      radius: radius.card,
      okColor: semantic.status.positive,
      warnColor: semantic.status.warning,
      errorColor: semantic.status.danger,
    },
    navigation: {
      sidebarBackground: semantic.surface.base,
      activeBackground: semantic.surface.brandTint,
      activeIndicator: semantic.action.primary,
      itemRadius: radius.control,
    },
    commandBar: {
      background: semantic.surface.elevated,
      radius: radius.card,
      border: `1px solid ${semantic.border.subtle}`,
    },
    stepper: {
      activeColor: semantic.action.primary,
      completedColor: semantic.status.positive,
      lineColor: semantic.border.subtle,
    },
    achievementBadge: {
      standardRadius: radius.hero,
      rareGlow: `0 0 0 3px ${semantic.surface.brandTint}`,
    },
  };
}
